module.exports = __webpack_public_path__ + "img/pt-header.97f4ddb5.jpg";